import React, 
       { useEffect, 
         useState }                 from 'react';
import { useNavigate }              from 'react-router-dom';
import { Container, 
         Form, 
         Button,
         Row, 
         Col}                       from 'react-bootstrap';
import api                          from './AxiosConfig';

function GoalDetailsUpdateRM( props ) {
  const [goal,    setGoal]          = useState();
  const [message, setMessage]       = useState( "" );
  const navigate                    = useNavigate();

 useEffect(() => {
    if (props && props.goal) {
        setGoal(props.goal);
    }
  }, [props]); // Runs when initialData changes

  // Format date for date form control.
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
       
  // Handle input change
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setGoal((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdateDetails = async () => {
       try {
           const response = await api.put(`/site/goals/${encodeURIComponent(goal.id)}`, { goal }, {withCredentials: true });
           console.log("PUT /site/goals/ = " + JSON.stringify(response.data));
           setMessage(response.data.message);
       } catch (error) {
           console.log("subGoalRow: " + error);
       }
  }
       
  const handleArchiveGoal = async () => {
        try {
            const response = await api.put(`/site/goals/archived/${encodeURIComponent(goal.id)}/1`, { goal }, {withCredentials: true });
            setMessage(response.data.message);  // Display success message from server
            navigate('/status', {});
        } catch (error) {
            if (error.response) {
                // The updated goal record is returned if the update was successful.
                setMessage(error.response.data.message);  // Display error message from server
            } else {
                setMessage('An error occurred during update');
            }
        }
    };

         
         
  return (
    <Container className="mt-4">
      { goal ? ( 
      <>
      <Form>
        {/* Goal Title */}
        <Form.Group as={Row} className="mb-3" controlId="formTitle">
          <Form.Label column className="text-end">
            Title
          </Form.Label>
          <Col>
            <Form.Control type="text" value={goal.goal_title} name="goal_title" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Goal Description */}
        <Form.Group as={Row} className="mb-3" controlId="formDescription">
          <Form.Label column className="text-end">
            Description
          </Form.Label>
          <Col>
            <Form.Control type="text" value={goal.goal_description} name="goal_description" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Target Date */}
        <Form.Group as={Row} className="mb-3" controlId="formTargetDate">
          <Form.Label column className="text-end">
            Target Date
          </Form.Label>
          <Col>
            <Form.Control type="date" value={formatDate(goal.target_date)} name="target_date" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Start Date */}
        <Form.Group as={Row} className="mb-3" controlId="formStartDate">
          <Form.Label column className="text-end">
            Start Date
          </Form.Label>
          <Col>
            <Form.Control type="date" value={formatDate(goal.start_date)} name="start_date" onChange={handleInputChange} />
          </Col>
        </Form.Group>
         
        {/* Submit Button */}
        <Form.Group as={Row} className="mt-4">
          <Col className="text-center">
            <Button variant="primary" size="sm" onClick={() => handleUpdateDetails()}>
              Update Details
            </Button>
          </Col>
          <Col className="text-end">
            <Button variant="primary" size="sm" onClick={() => handleArchiveGoal()}>
              Archive Goal
            </Button>
          </Col>
        </Form.Group>
      </Form>
      <p>{message}</p>
      </> ) : ( <p>Loading data...</p> )}
    </Container>           
  );
}

export default GoalDetailsUpdateRM;
